module.exports = __webpack_public_path__ + "media/site/images/products/eplaning-flat-screen2@2x-581bf6264951f1515a35de839ba04574.png";